import { NgModule } from '@angular/core';
import { CircleTimerComponent } from './circle-timer.component';

@NgModule({
  declarations: [CircleTimerComponent],
  exports: [CircleTimerComponent]
})
export class CircleTimerModule { }
